/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'

import { formatDate, paginatePages } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import axios from 'axios'
import { API } from '../../shared/API'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import urlSearchParams from '../../components/urlSearchParams'
import { useDownload } from '../../hooks/Download/useDownload'

export default function Reward() {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()

  const [paginate, setPaginate] = useState(false)
  const [rewards, setRewards] = useState(false)
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterReward = rewards && rewards.filter((val) => val.employee.toLowerCase().includes(searchQuery.toLowerCase()))
  const [page, setPage] = React.useState(1)
  console.log({ paginate })
  const noOfPages = paginate && paginate.totalPage

  const getAllReward = async (dto = {}) => {
    setLoading(true)
    console.log(dto)
    await axios
      .get(API.GET_ALL_REWARD(urlSearchParams(dto)), header)
      .then((data) => {
        setLoading(false)
        console.log({ data })
        setRewards(data.data.data)
        setPaginate(data.data.paginate)
      })
      .catch((err) => {
        console.log({ err })
      })
  }

  useEffect(() => {
    getAllReward({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    // const GET_ALL_REWARD
    getPdfCsvData('GET_ALL_REWARD')
  }, [])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  if (!loading && filterReward.length > 0) {
    tableBody = filterReward.map((item) => {
      return [
        { value: item.employee },
        { value: `${item.moduleData.attendance.toFixed(2)} %` },
        { value: `${item.moduleData.sales.toFixed(2)} %` },
        { value: `${item.moduleData.audit.toFixed(2)} %` },
        { value: `${item.moduleData.learning.toFixed(2)} %` },
        { value: `${item.total.toFixed(2)} %` },
        { value: item.regionRank },
        { value: item.zoneRank },
      ]
    })
  }

  const layoutProps = {
    heading: 'Rewards',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    filename: 'rewards',
    permissionName: 'Audit',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Employee', 'Attendance', 'Sales', 'Audit', 'Learning', 'Total', 'Region Rank', 'Zone Rank']}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      paginateFront
    />
  )
}
